export default __webpack_public_path__ + "static/media/venture_capital_step_en.942bf416.svg";